import React from 'react';
import { Card, Col, Row, Skeleton, Typography } from 'antd';
import { AuditOutlined, TeamOutlined, MessageOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;
const nf = new Intl.NumberFormat();

const THEMES = {
  cta: { deep: '#ffece8', light: '#fffaf8', icon: '#ff7a45' },
  users: { deep: '#e6f4ff', light: '#fcfeff', icon: '#1677ff' },
  conv: { deep: '#f3e8ff', light: '#fdfbff', icon: '#9254de' },
  acc: { deep: '#e6fffb', light: '#ffffff', icon: '#36cfc9' },
};

function StatCard({ title, icon, loading, total, added, suffix, theme }) {
  const colors = THEMES[theme] || THEMES.users;
  const cardStyle = {
    height: 132,
    borderRadius: 12,
    backgroundImage: `linear-gradient(315deg, ${colors.deep} 0%, ${colors.light} 100%)`,
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
  };

  return (
    <Card style={cardStyle} styles={{ body: { padding: 16 } }} variant="borderless">
      {loading ? (
        <Skeleton active paragraph={false} />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text style={{ color: '#595959' }}>{title}</Text>
            <span style={{ fontSize: 22, color: colors.icon }}>{icon}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', marginTop: 8 }}>
            <div style={{ fontSize: 34, fontWeight: 600, lineHeight: 1 }}>
              {typeof total === 'number' ? nf.format(total) : total}
              {suffix ? <span style={{ fontSize: 18, marginLeft: 4 }}>{suffix}</span> : null}
            </div>
            {typeof added === 'number' && (
              <Text style={{ marginLeft: 8 }} type="success">+{nf.format(added)}</Text>
            )}
          </div>
        </div>
      )}
    </Card>
  );
}

export default function SummaryCards({ loading, data }) {
  const conv = data?.conversations;
  const cta = data?.ctas;
  const users = data?.users;
  const accuracy = data?.accuracy;

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} md={6} lg={6} xl={6}>
        <StatCard
          title="Total CTA"
          icon={<AuditOutlined />}
          loading={loading}
          total={cta?.totalCtas}
          added={cta?.newCtas ?? undefined}
          theme="cta"
        />
      </Col>
      <Col xs={24} sm={12} md={6} lg={6} xl={6}>
        <StatCard
          title="Total Users"
          icon={<TeamOutlined />}
          loading={loading}
          total={users?.totalUsers}
          added={users?.newUsers ?? undefined}
          theme="users"
        />
      </Col>
      <Col xs={24} sm={12} md={6} lg={6} xl={6}>
        <StatCard
          title="Total Conversations"
          icon={<MessageOutlined />}
          loading={loading}
          total={conv?.totalConversations}
          added={conv?.newConversations ?? undefined}
          theme="conv"
        />
      </Col>
      <Col xs={24} sm={12} md={6} lg={6} xl={6}>
        <StatCard
          title="Accuracy"
          icon={<CheckCircleOutlined />}
          loading={loading}
          total={
            typeof accuracy?.accuracyRate === 'number' 
              ? accuracy.accuracyRate 
              : 'N/A'
          }
          suffix={
            typeof accuracy?.accuracyRate === 'number' 
              ? '%' 
              : undefined
          }
          theme="acc"
        />
      </Col>
    </Row>
  );
}


